var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tr-modal justify-center",class:{ 'tr-display-open': _vm.open, 'tr-display-close': !_vm.open },attrs:{"id":"tr-modal"}},[_c('q-card',{staticClass:"tr-modal-content mobile",attrs:{"flat":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }